import { render, staticRenderFns } from "./AnnouncementCloseHorizontal.html?vue&type=template&id=640d7a6a&scoped=true&external"
import script from "./AnnouncementCloseHorizontal.vue?vue&type=script&lang=js"
export * from "./AnnouncementCloseHorizontal.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementCloseHorizontal.scss?vue&type=style&index=0&id=640d7a6a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640d7a6a",
  null
  
)

export default component.exports